/**
 * Utility functions for date parsing and extracting timestamps from record objects.
 */

export const parseAnyDate = (val) => {
	if (!val) return 0;
	if (typeof val === "number") return val;
	if (val instanceof Date) return val.getTime();

	if (typeof val === "string") {
		const trimmed = val.trim();
		if (!trimmed) return 0;

		// 1. Check for DD/MM/YYYY or DD-MM-YYYY format (e.g., "24/09/2026 11:39:31 PM", "28-09-2026 15:24:14")
		const ddmmyyyyMatch = trimmed.match(
			/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})(?:\s+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?(?:\s*(AM|PM))?)?/i
		);

		if (ddmmyyyyMatch) {
			const day = parseInt(ddmmyyyyMatch[1], 10);
			const month = parseInt(ddmmyyyyMatch[2], 10) - 1;
			const year = parseInt(ddmmyyyyMatch[3], 10);
			let hours = ddmmyyyyMatch[4] ? parseInt(ddmmyyyyMatch[4], 10) : 0;
			const minutes = ddmmyyyyMatch[5] ? parseInt(ddmmyyyyMatch[5], 10) : 0;
			const seconds = ddmmyyyyMatch[6] ? parseInt(ddmmyyyyMatch[6], 10) : 0;
			const ampm = ddmmyyyyMatch[7] ? ddmmyyyyMatch[7].toUpperCase() : null;

			if (ampm === "PM" && hours < 12) {
				hours += 12;
			} else if (ampm === "AM" && hours === 12) {
				hours = 0;
			}

			const parsed = new Date(year, month, day, hours, minutes, seconds).getTime();
			if (!isNaN(parsed)) return parsed;
		}

		// 2. Standard ISO or other parseable date strings
		const parsedStandard = new Date(trimmed).getTime();
		if (!isNaN(parsedStandard)) return parsedStandard;
	}

	return 0;
};

/**
 * Formats a date input value ("YYYY-MM-DD", what <input type="date"> gives) as "DD-MM-YYYY".
 * Returns "" for anything else.
 */
export const toDDMMYYYY = (isoLike) => {
	if (!isoLike || typeof isoLike !== "string") return "";
	const parts = isoLike.split("-");
	if (parts.length !== 3) return "";
	const [y, m, d] = parts;
	if (!y || !m || !d) return "";
	return `${d}-${m}-${y}`;
};

export const getRecordDate = (rec) => {
	if (!rec) return 0;
	return (
		parseAnyDate(rec.modified_at) ||
		parseAnyDate(rec.modificationDate) ||
		parseAnyDate(rec.modification_date) ||
		parseAnyDate(rec.updated_at) ||
		parseAnyDate(rec.updatedAt) ||
		parseAnyDate(rec.started_at) ||
		parseAnyDate(rec.start_time) ||
		parseAnyDate(rec.created_at) ||
		parseAnyDate(rec.createdAt) ||
		parseAnyDate(rec.created) ||
		0
	);
};
